// Components/TaxTable.jsx
import React from "react";
import { taxColumns } from "./TaxData";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTable from "../../../../../../Common/DataTable/DataTable";


const TaxTable = ({ data, loading, onEdit, onDelete }) => {
  const tableData = data.map((t, idx) => ({
    sno: idx + 1,
    name: t.name,
    percentage: `${t.percentage}%`,
    type: t.type,
    actions: (
      <>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          onClick={() => onEdit(t)}
        >
          <i className="bi bi-pencil-square"></i>
        </button>

        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => onDelete(t.id)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </>
    ),
  }));

  return (
    <>
      <DataTableHeader />
      {loading ? (
        <div className="text-center py-4">
          <div className="spinner-border" />
        </div>
      ) : (
        <DataTable columns={taxColumns} data={tableData} />
      )}
    </>
  );
};

export default TaxTable;
